import axios from "axios";
import { url } from "./apiurl";

export const getErrors = () =>
  axios.get(url + "/error", { withCredentials: true });

export const postError = (error) =>
  axios.post(url + "/error", { error }, { withCredentials: true });
